import { useQuery } from '@tanstack/react-query'
import { Link, type NotFoundRouteProps } from '@tanstack/react-router'
import { CircleQuestionMark } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@shadcn/button'

import { querySession } from '@api/session/session.queries'

const NotFound = (_: NotFoundRouteProps) => {
  const { t } = useTranslation()
  const { data: session } = useQuery(querySession())

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-6 py-12">
      <div className="flex items-center gap-2">
        <CircleQuestionMark className="text-fg-brand-primary-600 size-8" />
        <span className="text-lg font-semibold">{t('not-found.title')}</span>
      </div>
      <Link to={session ? '/app/dashboard' : '/session/login'}>
        <Button size="ghost" variant="ghostPrimary">
          {t('not-found.button')}
        </Button>
      </Link>
    </div>
  )
}

export default NotFound
